{
  "name": "acre-app",
  "main": "expo-router/entry",
  "version": "1.96.0",
  "build": "178",
  "engines": {
    "node": "22"
  },
  "scripts": {
    "setup": "npx @dotenvx/dotenvx run -- npx vite-node scripts/vite/setup",
    "start": "expo start --clear",
    "start:dev": "EXPO_PUBLIC_IS_E2E=false expo start --clear",
    "start:e2e": "EXPO_PUBLIC_IS_E2E=true expo start --no-dev --minify --clear",
    "start:e2e:web": "expect -c 'spawn npm run start:e2e; expect eof' && rm -rf dist && npm run web:export-and-serve",
    "android": "rm -rf android && npm run compile-plugins && EAS_BUILD_PLATFORM=android expo run:android",
    "android:release": "rm -rf android && expo run:android --variant release -d",
    "ios": "rm -rf ios && EAS_BUILD_PLATFORM=ios expo run:ios",
    "ios:cached": "EAS_BUILD_PLATFORM=ios expo run:ios",
    "ios:release": "rm -rf ios && expo run:ios --configuration Release -d",
    "ota:pr": "vite-node scripts/ota-pr.ts",
    "eas:login": "./node_modules/.bin/dotenvx run -- eas login",
    "eas:app:staging:development-simulator": "EXPO_TOKEN=$CI_EXPO_TOKEN npx eas build --platform ios --profile development-simulator --non-interactive --json > eas-build-output.json",
    "eas:app:staging:development-emulator": "EXPO_TOKEN=$CI_EXPO_TOKEN npx eas build --platform android --profile development-simulator --non-interactive --json > eas-build-output.json",
    "eas:app:staging": "./node_modules/.bin/dotenvx run -- eas build --platform ios --profile staging",
    "eas:env:staging": "./node_modules/.bin/dotenvx run -- eas env:pull --environment preview",
    "eas:production:js": "npx eas update --clear-cache --channel production --environment production --message \"releasing js bundle to production\" && npx sentry-expo-upload-sourcemaps dist",
    "eas:download": "dotenvx run -- vite-node scripts/download-latest-eas-build.ts",
    "eas-build-pre-install": "npm run setup",
    "detox:local:simulator": "detox --configuration ios.sim.local.debug test",
    "detox:staging:simulator": "detox --configuration ios.sim.staging.debug --retries 2 test",
    "check-xcode-version": "vite-node scripts/check-xcode-version.ts",
    "cy:open": "cypress open",
    "cy:run": "cypress run --browser chrome",
    "web": "EAS_BUILD_PLATFORM=web expo start --web",
    "web:export": "npx @dotenvx/dotenvx run -- npx expo export -p web --dump-sourcemap",
    "web:serve-without-support-for-nested-routes": "expo serve",
    "web:serve": "npx serve dist -p 8081 -s",
    "web:export-and-serve": "npm run web:export && npm run web:serve",
    "test": "jest --watchAll",
    "test:final": "jest",
    "test:update": "jest -u",
    "prettier": "prettier --ignore-unknown",
    "format": "NODE_OPTIONS=--max-old-space-size=8192 npm run lint -- --fix . && npm run prettier -- --write *",
    "lint": "eslint",
    "prepare": "husky",
    "storybook-generate": "sb-rn-get-stories",
    "check-types": "tsc --noEmit",
    "expo:generate": "npm run compile-plugins && expo customize tsconfig.json",
    "graphql:generate:mesa": "graphql-codegen --config graphql.config.ts",
    "graphql:generate:mesa:watch": "graphql-codegen --config graphql.config.ts --watch",
    "graphql:generate:highnote": "graphql-codegen --config graphql.config.ts --project highnote",
    "deeplink-association:generate": "vite-node scripts/generate-deeplink-association.ts",
    "generate": "concurrently --group --timings --kill-others-on-fail --prefix-colors auto --names mesa,highnote,expo,deeplink-association \"npm run graphql:generate:mesa\" \"npm run graphql:generate:highnote\" \"npm run expo:generate\" \"npm run deeplink-association:generate\"",
    "compile-plugins": "tsc ./plugins/*.ts --outDir ./plugins --skipLibCheck",
    "mesa:check-current-packages-against-deployed-packages": "npx @dotenvx/dotenvx run -- npx vite-node scripts/vite/check-current-packages-against-deployed-packages.mts",
    "mesa:generate-mortgage-state-json": "vite-node scripts/vite/mortgage-generate-state-json/index.mts",
    "postinstall": "patch-package && npm run generate && npm run check-xcode-version && vite-node scripts/patch-braze-plist.ts"
  },
  "lint-staged": {
    "*.{cjs,mjs,js,jsx,ts,tsx,json}": "npm run lint -- --fix",
    "*": "npm run prettier -- --write"
  },
  "jest": {
    "preset": "jest-expo",
    "transformIgnorePatterns": [
      "/node_modules/(?!((jest-)?react-native|@react-native(-community)?|expo(nent)?|@expo(nent)?/.*|@expo-google-fonts/.*|react-navigation|@react-navigation/.*|@unimodules/.*|unimodules|sentry-expo|native-base|react-native-svg|@segment/.*))/"
    ],
    "collectCoverage": true,
    "collectCoverageFrom": [
      "src/app/**/*.{ts,tsx}",
      "!**/coverage/**",
      "!**/node_modules/**"
    ]
  },
  "dependencies": {
    "@acre-rewards/lib": "0.0.0-e0aa6142",
    "@apollo/client": "3.13.8",
    "@babel/plugin-proposal-export-namespace-from": "7.18.9",
    "@braze/expo-plugin": "3.1.0",
    "@braze/react-native-sdk": "17.0.1",
    "@braze/web-sdk": "5.8.1",
    "@expo-google-fonts/plus-jakarta-sans": "0.4.1",
    "@expo-google-fonts/poppins": "0.4.0",
    "@expo/match-media": "0.4.0",
    "@expo/metro-runtime": "5.0.5",
    "@expo/vector-icons": "14.1.0",
    "@google-cloud/recaptcha-enterprise-react-native": "18.7.1",
    "@gorhom/bottom-sheet": "5.1.6",
    "@hookform/resolvers": "5.2.1",
    "@octokit/auth-token": "6.0.0",
    "@octokit/core": "5.2.1",
    "@react-native-async-storage/async-storage": "2.1.2",
    "@react-native-firebase/app": "23.4.1",
    "@react-native-firebase/crashlytics": "23.4.1",
    "@react-native-picker/picker": "2.11.1",
    "@reduxjs/toolkit": "2.9.0",
    "@sardine-ai/react-js-wrapper": "1.0.14",
    "@sardine-ai/sardine-sdk-expo": "0.3.17",
    "@segment/analytics-next": "1.76.0",
    "@segment/analytics-react-native": "2.20.3",
    "@segment/analytics-react-native-plugin-appsflyer": "0.8.0",
    "@sentry/react-native": "7.7.0",
    "@statsig/expo-bindings": "3.8.3",
    "@statsig/react-bindings": "3.8.3",
    "@tamagui/animations-moti": "1.129.19",
    "@tamagui/config": "1.129.19",
    "@tamagui/use-previous": "1.129.19",
    "@types/react-native-web": "0.19.1",
    "@types/semver": "7.5.8",
    "core-js": "3.40.0",
    "deprecated-react-native-prop-types": "5.0.0",
    "expo": "53.0.23",
    "expo-application": "6.1.5",
    "expo-asset": "11.1.7",
    "expo-blur": "14.1.5",
    "expo-build-properties": "0.14.8",
    "expo-clipboard": "7.1.5",
    "expo-constants": "17.1.7",
    "expo-contacts": "14.2.5",
    "expo-crypto": "14.1.5",
    "expo-dev-client": "5.2.4",
    "expo-device": "7.1.4",
    "expo-document-picker": "13.1.6",
    "expo-file-system": "18.1.11",
    "expo-font": "13.3.2",
    "expo-haptics": "14.1.4",
    "expo-image": "2.4.1",
    "expo-image-picker": "16.1.4",
    "expo-linear-gradient": "14.1.5",
    "expo-linking": "7.1.7",
    "expo-mail-composer": "14.1.6",
    "expo-network": "7.1.5",
    "expo-notifications": "0.31.4",
    "expo-router": "5.1.7",
    "expo-screen-orientation": "8.1.7",
    "expo-sms": "13.1.4",
    "expo-splash-screen": "0.30.10",
    "expo-status-bar": "2.2.3",
    "expo-store-review": "8.1.5",
    "expo-system-ui": "5.0.11",
    "expo-tracking-transparency": "5.2.4",
    "expo-updates": "0.28.17",
    "expo-web-browser": "14.2.0",
    "graphql": "16.11.0",
    "joi": "17.13.3",
    "libphonenumber-js": "1.12.27",
    "lodash": "4.17.21",
    "luxon": "3.6.1",
    "mailslurp-client": "15.21.0",
    "metro": "0.82.5",
    "metro-cache": "0.82.5",
    "metro-cache-key": "0.82.5",
    "metro-config": "0.82.5",
    "metro-transform-worker": "0.82.5",
    "moti": "0.30.0",
    "npm-force-resolutions": "0.0.10",
    "react": "19.0.0",
    "react-dom": "19.0.0",
    "react-hook-form": "7.62.0",
    "react-native": "0.79.6",
    "react-native-animatable": "1.4.0",
    "react-native-appsflyer": "6.17.2",
    "react-native-currency-input": "1.1.1",
    "react-native-date-picker": "5.0.4",
    "react-native-element-dropdown": "2.12.1",
    "react-native-error-boundary": "1.2.4",
    "react-native-get-random-values": "1.11.0",
    "react-native-google-places-autocomplete": "2.5.6",
    "react-native-markdown-display": "7.0.2",
    "react-native-mask-input": "1.2.3",
    "react-native-otp-entry": "1.8.4",
    "react-native-picker-select": "9.0.1",
    "react-native-plaid-link-sdk": "10.13.2",
    "react-native-reanimated": "3.19.4",
    "react-native-reanimated-confetti": "1.3.1",
    "react-native-safe-area-context": "5.4.0",
    "react-native-screens": "4.11.1",
    "react-native-shimmer-placeholder": "2.0.9",
    "react-native-svg": "15.11.2",
    "react-native-toast-message": "2.2.1",
    "react-native-web": "0.20.0",
    "react-native-webview": "13.13.5",
    "react-plaid-link": "4.0.1",
    "react-redux": "9.2.0",
    "react-responsive": "10.0.1",
    "redux": "5.0.1",
    "semver": "7.6.3",
    "serialize-error": "12.0.0",
    "tamagui": "1.129.19",
    "text-encoding-polyfill": "0.6.7",
    "zod": "3.25.76",
    "zustand": "5.0.5"
  },
  "devDependencies": {
    "@actions/core": "1.11.1",
    "@actions/github": "6.0.0",
    "@babel/core": "7.26.0",
    "@config-plugins/detox": "11.0.0",
    "@dotenvx/dotenvx": "1.47.5",
    "@eslint/js": "9.14.0",
    "@graphql-codegen/cli": "5.0.2",
    "@graphql-codegen/client-preset": "4.3.3",
    "@parcel/watcher": "2.4.1",
    "@react-native-community/datetimepicker": "8.4.1",
    "@react-native-community/slider": "4.5.6",
    "@sardine-ai/sardine-expo-config": "0.1.6",
    "@segment/sovran-react-native": "1.1.3",
    "@slack/web-api": "7.9.1",
    "@slack/webhook": "7.0.5",
    "@storybook/addon-ondevice-actions": "9.1.4",
    "@storybook/addon-ondevice-controls": "9.1.4",
    "@storybook/react": "9.1.13",
    "@storybook/react-native": "9.1.4",
    "@tamagui/metro-plugin": "1.129.19",
    "@types/eslint__js": "8.42.3",
    "@types/fs-extra": "11.0.4",
    "@types/jest": "29.5.12",
    "@types/lodash": "4.17.14",
    "@types/luxon": "3.6.2",
    "@types/plist": "3.0.5",
    "@types/react": "19.0.10",
    "@typescript-eslint/eslint-plugin": "8.38.0",
    "@typescript-eslint/parser": "8.38.0",
    "auth0": "4.21.0",
    "babel-loader": "8.3.0",
    "commander": "6.2.1",
    "concurrently": "9.1.2",
    "cypress": "15.5.0",
    "cypress-xpath": "2.0.1",
    "detox": "20.42.0",
    "dotenv": "16.4.5",
    "eas-cli": "16.24.1",
    "eslint": "8.57.1",
    "eslint-config-prettier": "9.1.0",
    "eslint-plugin-expo": "0.1.0",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-n": "16.6.2",
    "eslint-plugin-prettier": "5.5.0",
    "eslint-plugin-promise": "6.1.1",
    "eslint-plugin-react": "7.37.4",
    "eslint-plugin-react-hooks": "5.0.0",
    "expo-sharing": "13.1.5",
    "graphql-config": "5.1.1",
    "husky": "9.0.11",
    "inquirer": "12.5.2",
    "jest": "29.7.0",
    "jest-expo": "53.0.10",
    "jest-junit": "16.0.0",
    "jest-snapshot-prettier": "npm:prettier@3.6.0",
    "junit2json": "3.1.15",
    "lightningcss": "1.30.2",
    "lint-staged": "15.2.10",
    "patch-package": "8.0.0",
    "plist": "3.1.0",
    "prettier": "3.6.0",
    "react-native-gesture-handler": "2.24.0",
    "redux-devtools-expo-dev-plugin": "1.0.0",
    "serve": "14.2.4",
    "sharp": "0.34.5",
    "thumbhash": "0.1.1",
    "typescript": "5.8.3",
    "typescript-eslint": "8.38.0",
    "uri-scheme": "1.4.0",
    "vite-node": "3.2.4"
  },
  "optionalDependencies": {
    "@esbuild/linux-x64": "*",
    "@rollup/rollup-linux-x64-gnu": "*",
    "@sentry/cli-linux-x64": "*"
  },
  "resolutions": {
    "promise": "^8.3.0"
  },
  "overrides": {
    "@sardine-ai/react-js-wrapper": {
      "react": "$react",
      "react-dom": "$react-dom"
    },
    "@expo/prebuild-config": "9.0.12"
  },
  "private": true
}
